import React from 'react'

export default function NewFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer app-theme-footer" role="contentinfo">
      <div className="app-theme-footer__inner">
        <div className="app-theme-footer__brand">
          <strong>CMU Landscape Net Zero</strong>
          <span>ระบบติดตามข้อมูลกิจกรรม มาตรการ และเอกสารในรูปแบบที่ใช้งานง่าย</span>
        </div>
        <div className="app-theme-footer__meta">
          <span>Copyright &copy; CMU {currentYear}</span>
          <small>Designed for clarity, consistency, and faster data entry V.1.2</small>
        </div>
      </div>
    </footer>
  )
}
